import React, { ReactElement, useState } from "react";

import { KeyboardArrowDown } from "@material-ui/icons";
import { Button, ButtonGroup, Menu, MenuItem } from "@portex-pro/ui-components";
import values from "lodash/values";
import { useTranslation } from "react-i18next";
import { TrailerType } from "types/TrailerType";

import { containerTypes } from "../const";

interface ContainerTypeButtonGroupViewProps {
  value?: TrailerType; // expected to be a narrowed ContainerType
  onChange?: (value: TrailerType) => void;
  showError?: boolean;
}

const ContainerTypeButtonViewGroup = ({
  value,
  onChange,
  showError = false,
}: ContainerTypeButtonGroupViewProps): ReactElement => {
  const { t } = useTranslation(["shipper", "common"]);
  const { DRY, REEFER, ...remainingContainerTypes } = containerTypes;
  const visibleTypes = [DRY, REEFER];
  const dropdownTypes = values(remainingContainerTypes);

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const isMenuSelected = dropdownTypes.some((t) => t === value);

  return (
    <>
      <ButtonGroup state={showError && !value ? "error" : undefined} color="primary" fullWidth>
        {visibleTypes.map((type) => (
          <Button key={type} className={value === type ? "Por-selected" : ""} onClick={() => onChange?.(type)}>
            {t(`common:trailerTypes.${type}`)}
          </Button>
        ))}
        <Button
          id="container-type-button"
          aria-controls="container-type-menu"
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          className={isMenuSelected ? "Por-selected" : ""}
          onClick={handleClick}
          endIcon={<KeyboardArrowDown />}
        >
          {value && isMenuSelected ? t(`common:trailerTypes.${value}`) : t("shipper:other")}
        </Button>
      </ButtonGroup>
      <Menu
        id="container-type-menu"
        aria-labelledby="container-type-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        {dropdownTypes.map((type) => (
          <MenuItem
            key={type}
            selected={value === type}
            onClick={() => {
              onChange?.(type);
              handleClose();
            }}
          >
            {t(`common:trailerTypes.${type}`)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ContainerTypeButtonViewGroup;
